
import { defineComponent } from 'vue';
import { Panier } from '@/types/Panier';
import commonMessages from '../locales/common';
import { ProduitDCDTO } from '@/types/store/DTO/ProduitDCDTO';
export default defineComponent({
  name: 'ApplicationFrom',
  data() {
    return {
      // poisson: false,
      // gibier: false,
      // saumon: false,
      isDisabled: true,
      ico: 'far',
      panier: {} as Panier,
      produitsDC: {} as Array<ProduitDCDTO>,
      cart: [] as Array<ProduitDCDTO>,
    };
  },
  i18n: {
    sharedMessages: commonMessages,
    messages: {
      en: {
        consigne: 'Indicate the desired box(es) ($20 fee for the box of fish):',
        faireDemande: 'Make a request',
      },
      fr: {
        consigne:
          'Indiquez la ou les boîtes désirées (frais de 20$ pour la boite de poisson) :',
        faireDemande: 'Faire la demande',
      },
    },
  },
  methods: {
    checkDisabled() {
      if (!this.poisson && !this.gibier && !this.saumon) {
        this.isDisabled = true;
        this.ico = 'far';
      } else {
        this.isDisabled = false;
        this.ico = 'fas';
      }
    },
    addRemoveFishBasket() {
      this.panier.poisson = this.poisson;
      sessionStorage.panier = JSON.stringify(this.panier);
      this.checkDisabled();
    },
    addRemoveSaumonBasket() {
      this.panier.saumon = this.saumon;
      sessionStorage.panier = JSON.stringify(this.panier);
      this.checkDisabled();
    },
    addRemoveGibierBasket() {
      this.panier.gibier = this.gibier;
      sessionStorage.panier = JSON.stringify(this.panier);
      this.checkDisabled();
    },
    goToConfimation() {
      this.$router.push('/order-validation');
    },
    getAge() {
      return sessionStorage.age;
    },
  },
  created() {
    if (sessionStorage.panier != undefined) {
      this.panier = JSON.parse(sessionStorage.panier);
      this.poisson = this.panier.poisson;
      this.gibier = this.panier.gibier;
      this.saumon = this.panier.saumon;
    }
    this.checkDisabled();
  },
});
